import { serializeDate, deserializeDate } from '../components/atoms/date-picker/date-picker-functions';

export const formatDateToYYYYMMDD = (date: Date): string => {
  return serializeDate(date);
};

export const createDateFromString = (dateStr: string): Date => {
  return deserializeDate(dateStr);
};

export const formatDatesInObject = <T>(obj: T): any => {
  if (!obj || typeof obj !== 'object') {
    return obj;
  }
  
  const result = {...obj};
  
  for (const key in result) {
    if (Object.prototype.hasOwnProperty.call(result, key)) {
      const value = result[key];
      
      if (value instanceof Date) {
        (result as any)[key] = formatDateToYYYYMMDD(value);
      }
    }
  }
  
  return result;
}; 